import {LOAD_SUCURSALES_SUCCESS, RecoleccionActionTypes} from "../types/recoleccionActionTypes";
import {Sucursal} from "../../entities/catalogos/Sucursal";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

function loadSucursalesSuccess(sucursales: Sucursal[]): RecoleccionActionTypes {
    return {
        type: LOAD_SUCURSALES_SUCCESS,
        sucursales
    }
}

export function loadSucursales(empresaId) {
    return function (dispatch) {
        return apiSource.obtener<Sucursal[]>("sucursal/many-company/" + empresaId)
            .then((result: Sucursal[]) => {
                let sucursales: Sucursal[] = [];
                result.forEach(r=> sucursales.push(new Sucursal(r)));

                dispatch(loadSucursalesSuccess(sucursales))
            })
            .catch(error => {
                //throw error;
            })
    }
}
